import React from 'react';
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    textTransform: 'none',
    width: props.width || 130,
    height: props.height || 45,
    fontWeight: 'normal',
  }),
}));

const buttonThemes = {
  main: createMuiTheme({
    palette: {
      primary: { main: '#00B9AD' },
      secondary: {
        main: '#004987',
      },
    },
    overrides: {
      MuiButton: {
        root: {
          borderRadius: '5px',
          fontSize: 16,
        },
        containedPrimary: {
          color: '#FFF',
          '&:hover': {
            backgroundColor: '#00B9AD',
          },
        },
        containedSecondary: {
          color: '#FFF',
          '&:hover': {
            backgroundColor: '#004987',
          },
        },
      },
    },
  }),
  secondary: createMuiTheme({
    palette: {
      primary: { main: '#C1D42F' },
    },
    overrides: {
      MuiButton: {
        root: {
          borderRadius: '5px',
          fontSize: 15,
        },
        containedPrimary: {
          color: '#004987',
          '&:hover': {
            backgroundColor: '#C1D42F',
          },
        },
      },
    },
    props: {
      MuiButtonBase: {
        disableRipple: true,
      },
    },
  }),
  rounded: createMuiTheme({
    palette: {
      primary: { main: '#004987' },
      secondary: {
        main: '#C1D42F',
      },
    },
    overrides: {
      MuiButton: {
        root: {
          borderRadius: '50px',
          fontSize: 14,
        },
        containedPrimary: {
          color: '#ffffff',
          '&:hover': {
            backgroundColor: '#004987',
          },
        },
      },
    },
  }),
};

export default function CustomizedButtons({
  theme = 'main',
  children,
  color,
  ...props
}) {
  const classes = useStyles(props);

  return (
    <ThemeProvider theme={buttonThemes[theme]}>
      <Button
        variant='contained'
        color={color || 'primary'}
        classes={{
          root: classes.root,
          containedPrimary: classes.containedPrimary,
          containedSecondary: classes.containedSecondary,
        }}
        {...props}>
        {children}
      </Button>
    </ThemeProvider>
  );
}
